import React, { useEffect, useState, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import { postData, postFormData, getData } from '../../services/RequestWrapper';
import ChoosePeriod from '../ChoosePeriod';

import {
	ResponsiveContainer,
	BarChart,
	Bar,
	XAxis,
	YAxis,
	Tooltip,
	CartesianGrid,
} from "recharts";

function MonthlyReport() {
	const [selectedPeriod, setSelectedPeriod] = useState(null);
	const [categories, setCategories] = useState([]);
	const [selectedCategories, setSelectedCategories] = useState([]);
	const [reportDataset, setReportDataset] = useState([]);

	//const expensesTableRef = useRef(null);

	const palette = [
		"#E6194B", "#3CB44B", "#FFE119", "#4363D8", "#F58231",
		"#911EB4", "#46F0F0", "#F032E6", "#BCF60C", "#FABEBE",
		"#008080", "#E6BEFF", "#9A6324", "#FFFAC8", "#800000",
		"#AAFFC3", "#808000", "#FFD8B1", "#000075", "#808080",
		"#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FF9F1C",
		"#6A4C93", "#2EC4B6", "#E71D36", "#A1C181", "#5E60CE"
	];
	
	useEffect(() => {
	}, [])

	const handlePeriodChange = (p) => {
		setSelectedPeriod(p);
		postFormData('/api/report/monthly/by/category/total', { periodId: p.id }).then(data => { setCategories(data); });
	};

	const handleCatgorySelected = (isChecked, categoryId) => {
		var res = [];
		if (selectedCategories.includes(categoryId)) {
			res = selectedCategories.filter(item => item !== categoryId)
		} else {
			res = [...selectedCategories, categoryId];
		}
		setSelectedCategories(res);

		if (res.length > 0) reloadReportData(selectedPeriod.id, res.join(','));
	}

	const reloadReportData = (p, c) => {
		postFormData('/api/report/monthly/by/category', { periodId: p, categoryId: c }).then(data => { setReportDataset(data); });
	};

	return (
		<div>
			<ChoosePeriod onPeriodChanged={handlePeriodChange} />

			{categories.map((category, index) => (
				<Form.Check type="checkbox" key={'k' + category.id} label={category.name + " (" + category.sum + ")"} onChange={e => handleCatgorySelected(e.target.value, category.id)} />
			))}			

			<br/>

			<ResponsiveContainer width="100%" height={500}>
				<BarChart data={reportDataset}>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="title" />
					<YAxis />
					<Tooltip />
					{categories.map((category, index) => (
						(selectedCategories.includes(category.id)) &&
						<Bar dataKey={category.name} stackId={"data_" + category.id} fill={palette[index]} />
					))}
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
}

export default MonthlyReport;